import { useTranslation } from 'react-i18next';
import type { UseFormReturn } from 'react-hook-form';
import { Input } from '@/components/Input';
import { Textarea } from '@/components/Textarea';
import { Select } from '@/components/Select';
import type { OpportunityFieldDefinition } from '@/pages/Opportunities/formFields';
import type { OpportunityFormValues } from '@/pages/Opportunities/formSchema';
import type { OpportunityCatalogs } from '@/pages/Opportunities/types';

export interface OpportunityFormFieldProps { field: OpportunityFieldDefinition; form: UseFormReturn<OpportunityFormValues>; catalogs: OpportunityCatalogs; }
export const OpportunityFormField = ({ field, form, catalogs }: OpportunityFormFieldProps) => {
    const { t } = useTranslation('global');
    const error = form.formState.errors[field.name]?.message;
    const label = t(`opportunities.fields.${field.name}`);
    if(field.catalog){
        return <Select label={label} required={field.required} searchable clearable={!field.required} value={form.watch(field.name)}
            onChange={(value: string) => form.setValue(field.name, String(value), { shouldDirty: true })}
            options={catalogs[field.catalog].map(item => ({ value: String(item.id), label: item.name }))} error={error} />;
    }
    if(field.type === 'textarea'){
        return <Textarea label={label} required={field.required} value={form.watch(field.name)} onChange={event => form.setValue(field.name, event.target.value, { shouldDirty: true })} error={error} />;
    }
    return <Input label={label} required={field.required} type={field.type === 'decimal' ? 'text' : field.type ?? 'text'} inputMode={field.type === 'decimal' ? 'decimal' : undefined}
        {...form.register(field.name)} error={error} helperText={field.type === 'decimal' ? t('opportunities.decimal_hint') : undefined} />;
};
